export default __webpack_public_path__ + "static/media/linkedinIcon.596d40bf.png";